export default __webpack_public_path__ + "media/images/images/flags/oh-81fe597d5c8ad89f9418839830884533.png";